<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="1200">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col>
        <v-text-field
          v-model="name"
          label="Name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          v-model="owner"
          :items="owners"
          label="Owner"
          :outlined="outlinedInputs"
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          v-model="description"
          label="Description"
          :outlined="outlinedInputs"
        ></v-textarea>
      </v-col>
    </v-row>
    <custom-data-types-attributes :customDataTypeId="id" />
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <v-row v-if="debug">
      <v-col>
        <code>{{ id }}</code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import { removeGQLTypename } from "../../../../helpers";
import BasicDialog from "../../shared/BasicDialog.vue";
import CustomDataTypesAttributes from "./CustomDataTypesAttributes.vue";
export default {
  name: "custom-data-type-edit-dialog",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Object,
      default: null,
    },
  },

  components: {
    BasicDialog,
    CustomDataTypesAttributes,
  },

  data() {
    return {
      debug: false,
      id: this.value ? this.value.id : null,
      name: this.value ? this.value.name : "",
      description: this.value ? this.value.description : "",
      owner: this.value ? this.value.owner : "ITINERARY",
      owners: ["ITINERARY", "SUPPLIER", "CLIENT", "USER"],
    };
  },

  computed: {
    editorTitle() {
      return this.value ? "Edit Custom Data Type" : "Create Custom Data Type";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.name != "" && this.owner != "";
    },
  },

  watch: {
    value(newValue) {
      this.id = newValue ? newValue.id : null;
      this.name = newValue ? newValue.name : "";
      this.description = newValue ? newValue.description : "";
      this.owner = newValue ? newValue.owner : "ITINERARY";
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.id ? this.id : undefined,
        name: this.name,
        description: this.description,
        owner: this.owner,
      });
    },
    onCreateNewAtrr() {
      console.log("Create New Attribute");
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/admin/cd-types/CustomDataTypeEditDialog.vue